import { render } from "./PsychologistViewClientView.vue?vue&type=template&id=f01d2cc0"
import script from "./PsychologistViewClientView.vue?vue&type=script&lang=js"
export * from "./PsychologistViewClientView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__